import request from '@/utils/request';
//重报检测
export function checkReapply(params){
  return request({
     url: '/api/v1/other/check_reapply_status',
     method: 'post',
     data: params
  });
};
//改报检测
export function checkEditapply(params){
  return request({
     url: '/api/v1/other/check_editapply_status',
     method: 'post',
     data: params
  });
};
//打印检测
export function checkPrint(params){
  return request({
     url: '/api/v1/other/check_print_ticket',
     method: 'post',
     data: params
  });
};
//查看成绩
export function getScore(params){
  return request({
     url: '/api/v1/other/select_achievement',
     method: 'post',
     data: params
  });
};
//支付检测
export function checkPay(params){
  return request({
     url: '/api/v1/other/check_pay_status',
     method: 'post',
     data: params
  });
};
//检查是否报名
export function checkApply(params){
  return request({
      url: '/api/v1/other/check_apply_jobs',
      method: 'post',
      data: params
  });
};
//重报获取数据
export function getApplyData(params){
  return request({
      url: '/api/v1/other/get_apply_data',
      method: 'post',
      data: params
  });
};

//获取地区树
export function getCity(params){
  return request({
      url: '/api/v1/other/getCity',
      method: 'post',
      data: params
  });
};

//获取底部信息
export function getCompanyInfo(params){
    return request({
        url: '/api/v1/other/getCompanyInfo',
        method: 'get',
        params
    });
};


// WEBPACK FOOTER //
// ./src/api/detection.js